exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\nbutton {\r\n  margin-right: 30px;\r\n}\r\n.dropdown-header {\r\n  font-weight: bold;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/websites/emusic-search-WA/emusic2018/emusic2018/SPA/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main